export default __webpack_public_path__ + "static/media/img4.994c23b6.png";